import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import colors from '../assets/colors'

Vue.use(Vuex)

export default () => {
  return new Vuex.Store({
    state: {
      application: window.APPLICATION,
      datasets: {},
      selectedInfos: {},
      codes: null,
      colors: null
    },
    getters: {
      tileserverUrl (state) {
        return state.application.apiUrl + '/remote-services/tileserver-koumoul/proxy'
      },
      config (state) {
        return state.application && state.application.configuration
      },
      levelsInfos (state, getters) {
        const levels = {}
        Object.values(state.datasets).forEach(dataset => {
          const fields = {
            iris: dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#codeIRIS'),
            communes: dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#codeCommune'),
            epci: dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#EtablissementPublicDeCooperationIntercommunale'),
            departements: dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#codeDepartement'),
            regions: dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#codeRegion')
          }
          for (const level of ['iris', 'communes', 'epci', 'departements', 'regions']) {
            if (fields[level]) {
              levels[level] = levels[level] || {}
              levels[level][dataset.id] = fields[level]
              break
            }
          }
        })
        return levels
      }
    },
    mutations: {
      setAny (state, params) {
        Object.assign(state, params)
      }
    },
    actions: {
      async init ({ commit, dispatch, state, getters }) {
        const datasets = {}
        for (const dataset of getters.config.datasets) {
          try {
            datasets[dataset.id] = (await axios.get(dataset.href)).data
            // if (info.shapes.type === 'circle' && info.shapes.radius.type === 'variable') {
            //   const params = { size: 1, select: info.shapes.radius.field, sort: info.shapes.radius.field, finalizedAt: datasets[info.dataset.id].finalizedAt }
            //   const minValueCircle = (await axios.get(datasets[info.dataset.id].href + '/lines', { params })).data.results.pop()[info.shapes.radius.field]
            //   params.sort = '-' + params.sort
            //   const maxValueCircle = (await axios.get(datasets[info.dataset.id].href + '/lines', { params })).data.results.pop()[info.shapes.radius.field]
            //   Object.assign(datasets[info.dataset.id], { minValueCircle, maxValueCircle })
            // }
          } catch (err) {
            dispatch('setError', err)
          }
        }
        commit('setAny', { datasets })
        if (getters.config.colors.type !== 'none') {
          if (getters.config.colors.type === 'enum') {
            commit('setAny', { colors: colors(getters.config.colors) })
          } else if (getters.config.colors.type === 'range') {
            if (getters.config.colors.rangeOptions.scheme.computed) {
              const params = { size: 1, select: getters.config.colors.rangeOptions.field, sort: getters.config.colors.rangeOptions.field, finalizedAt: datasets[getters.config.colors.rangeOptions.dataset.id].finalizedAt }
              const minValueColor = (await axios.get(datasets[getters.config.colors.rangeOptions.dataset.id].href + '/lines', { params })).data.results.pop()[getters.config.colors.rangeOptions.field]
              params.sort = '-' + params.sort
              const maxValueColor = (await axios.get(datasets[getters.config.colors.rangeOptions.dataset.id].href + '/lines', { params })).data.results.pop()[getters.config.colors.rangeOptions.field]
              const percents = [0, ...Array.from({ length: getters.config.colors.rangeOptions.ranges.size - 1 }, (_, i) => (i + 1) * (100 / getters.config.colors.rangeOptions.ranges.size)), 100].join(',')
              const metrics = (await axios.get(datasets[getters.config.colors.rangeOptions.dataset.id].href + '/metric_agg', { params: { field: getters.config.colors.rangeOptions.field, metric: 'percentiles', percents, finalizedAt: datasets[getters.config.colors.rangeOptions.dataset.id].finalizedAt } })).data.metric
              const quantiles = metrics.map((m, i) => ({ min: i ? metrics[i - 1].value : undefined, max: m.value })).slice(1)
              commit('setAny', { colors: colors(getters.config.colors, minValueColor, maxValueColor, quantiles) })
            } else {
              commit('setAny', { colors: colors(getters.config.colors) })
            }
          }
          dispatch('fetch')
        }
      },
      async fetch ({ commit, state, getters }) {
        const options = getters.config.colors.rangeOptions || getters.config.colors.enumOptions
        const infos = Object.values(getters.levelsInfos).find(i => i[options.dataset.id])
        const keyField = options.field
        const codes = {}
        let response
        let last = null
        const qp = {
          size: 10000,
          select: keyField + ',_i,' + infos[options.dataset.id].key,
          finalizedAt: state.datasets[options.dataset.id].finalizedAt
        }
        do {
          const params = Object.assign({ sort: '_i' }, qp)
          if (last) params.qs = `${params.qs ? (params.qs + ' AND ') : ''}_i:{${last} TO *]`
          response = (await axios.get(state.datasets[options.dataset.id].href + '/lines', { params })).data
          response.results.forEach(l => {
            if (getters.config.colors.enumOptions) {
              const color = state.colors.find(c => c.value === l[keyField])
              if (color) codes[l[infos[options.dataset.id].key]] = color.color
            } else if (getters.config.colors.rangeOptions) {
              const color = state.colors.find(c => c.min <= l[keyField] && c.max >= l[keyField])
              if (color) codes[l[infos[options.dataset.id].key]] = color.color
            }
          })
          // values = [].concat(values, )
          last = response.results[response.results.length - 1]._i
        } while (response.total > 10000)
        commit('setAny', { codes })
      },
      async setError ({ state }, error) {
        console.error('report error', error)
        try {
          axios.post(state.application.href + '/error', { message: error.message || error })
        } catch (err) {
          console.log('Failed to report error', err)
        }
      }
    }
  })
}
